import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AUTH_SIGNIN_ROUTE } from './shared/constants/routes';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: AUTH_SIGNIN_ROUTE,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
